import { Injectable } from "@angular/core";
import { Events } from "../events/events";

@Injectable({
  providedIn: 'root'
})
export class CurrentAddress {

  constructor(
    private events: Events
  ) {
  }

  get addressId() {
    return localStorage.getItem('addressId');
  }

  set addressId(addressId: string | null) {
    if (addressId !== null) {
      localStorage.setItem('addressId', addressId);
    } else {
      localStorage.removeItem('addressId');
    }
    this.events.publish('address:changed');
  }
}
